import { OrderStatus, OrderDetail } from 'api'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

export function getStagingStatusColor(orderDetail: Partial<OrderDetail>): string {
  const orderStatus = orderDetail.order?.status
  if (orderStatus === OrderStatus.INCOMPLETE) {
    return constants.STATUS_COLOR_INVALID
  } else if (orderStatus === OrderStatus.PREPARED) {
    return constants.STATUS_COLOR_STAGING_READY
  } else {
    return constants.STATUS_COLOR_UNPREPARED
  }
}

export function getStagingStatusText(orderStatus: OrderStatus): string {
  if (orderStatus === OrderStatus.INCOMPLETE) {
    return Locale.translate(Translation.TC_ERROR)
  } else if (orderStatus === OrderStatus.PREPARED) {
    return Locale.translate(Translation.TC_READY)
  } else {
    return Locale.translate(Translation.TC_UNPREPARED)
  }
}
